"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawerFooter = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var DrawerFooter = function (_a) {
    var _b = _a.align, align = _b === void 0 ? 'right' : _b, children = _a.children, className = _a.className, props = __rest(_a, ["align", "children", "className"]);
    var DrawerFooterClassNames = classnames_1.default('Drawer__footer', className, {
        'justify-content-start': align === 'left',
        'justify-content-center': align === 'center',
        'justify-content-end': align === 'right',
        'justify-content-between': align === 'space-between',
    });
    return (react_1.default.createElement("div", __assign({ className: DrawerFooterClassNames }, props), children));
};
exports.DrawerFooter = DrawerFooter;
//# sourceMappingURL=DrawerFooter.js.map